var exports = {
  "az": "Box__XbovWY",
  "NB": "editingCell__R5djk-",
  "OB": "disallowSelection__DU6u7v",
};

module.exports = exports;
